import { RootState } from '../redux/store';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from '../helpers/common';
import { IPaginationResponse } from '../interfaces/responces/IPagination.response';
import { IInventoryFilter } from '../interfaces/IInventoryItem';

export const stockItemsApi = createApi({
  reducerPath: 'inventoryApi',
  tagTypes: ['Inventory'],
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: async (headers, { getState }) => {
      const token = (getState() as RootState).user.info.accessToken;
      token && headers.set('Authorization', `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (build) => ({
    getInventoriesList: build.query<
      IPaginationResponse<any>,
      IInventoryFilter
    >({
      transformResponse: (response: { data: IPaginationResponse<any> }) =>
        response.data,
      query: (params) => ({
        url: `/stock-items/list`,
        method: 'GET',
        params,
      }),
      providesTags: (result) => ['Inventory'],
    }),
    getInventoryList: build.query<
      any,
      { page?: number; query?: string; state?: string }
    >({
      transformResponse: (response: { data: any }) => response.data,
      query: ({ page = 1, query = '', state = '' }) => ({
        url: `/stock-items`,
        method: 'GET',
        params: { page, query, state },
      }),
    }),
    getInventoryById: build.query<any, number>({
      transformResponse: (response: { data: any }) => response.data,
      query: (id) => ({
        url: `/stock-items/${id}`,
        method: 'GET',
      }),
    }),
    createInventory: build.mutation<any, any>({
      transformResponse: (response: { data: any }) => response.data,
      query: (data) => ({
        url: `/stock-items`,
        method: 'POST',
        body: data,
      }),
    }),
    updateInventory: build.mutation<any, { id: number; data: any }>({
      transformResponse: (response: { data: any }) => response.data,
      query: ({ id, data }) => ({
        url: `/stock-items/${id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    deleteInventory: build.mutation<any, number>({
      transformResponse: (response: { data: any }) => response.data,
      query: (id) => ({
        url: `/stock-items/${id}`,
        method: 'DELETE',
      }),
    }),
    getInventoryStats: build.query<any, void>({
      transformResponse: (response: { data: any }) => response.data,
      query: () => ({
        url: `/stock-items/stats`,
        method: 'GET',
      }),
    }),
    exportInventory: build.mutation<any, { ids: number[]; format?: string }>({
      transformResponse: (response: { data: any }) => response.data,
      query: ({ ids, format = 'xlsx' }) => ({
        url: `/inventories/export`,
        method: 'POST',
        body: { ids, format },
      }),
    }),
  }),
});

export const {
  useGetInventoriesListQuery,
  useGetInventoryListQuery,
  useGetInventoryByIdQuery,
  useCreateInventoryMutation,
  useUpdateInventoryMutation,
  useDeleteInventoryMutation,
  useGetInventoryStatsQuery,
  useExportInventoryMutation,
} = stockItemsApi;
